/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Awp = {
  __typename?: 'Awp';
  /** In-window results the reference document does not name. Same union as `biomarkers`, so one shape covers both; in practice only Biomarker occurs here, since an entry exists because a result came back. Reference metadata (unit, theme, themeCode, section, panel, questTestCode) is null — there is no document entry to draw it from. */
  additionalBiomarkers: Array<BiomarkerResult>;
  appointmentDate: Scalars['String']['output'];
  /** Every biomarker in the reference document, in its order — the same length for every patient. Each entry is either Biomarker (a result) or BiomarkerUnavailable (no result in the window). */
  biomarkers: Array<BiomarkerResult>;
  memberId: Scalars['String']['output'];
};

export type Biomarker = {
  __typename?: 'Biomarker';
  /** Null when the result carried no flag, i.e. a normal result. */
  abnormalFlag?: Maybe<Scalars['String']['output']>;
  accession: Scalars['String']['output'];
  collectedAt: Scalars['String']['output'];
  /** The other in-window results for this slot that the shown value superseded, newest first, in the same unit as `value`. Always supersededCount long; empty for a single draw. The shown value is unchanged by this list. */
  earlierResults: Array<EarlierResult>;
  loinc: Scalars['String']['output'];
  /** Which explicit rule placed this result in its slot. Null for an off-panel result, or when the reference document predates explicit mapping (schemaVersion 1). */
  matchedBy?: Maybe<MatchedBy>;
  name: Scalars['String']['output'];
  /** Quest's order panel, e.g. "Lipid Panel". Null off-panel, or when the document names none. */
  panel?: Maybe<Scalars['String']['output']>;
  /** Null for an off-panel result. */
  questTestCode?: Maybe<Scalars['String']['output']>;
  /** The reference table's tiers for this biomarker (e.g. Optimal / Moderate / High), in `unit`, sex-specific where the table defines it. Always from the table, even when referenceRange came from the lab's own range. Null for an off-panel result, when the table has no range, or when the result's unit does not match the table's. */
  referenceBands?: Maybe<Array<ReferenceBand>>;
  /** The normal range, resolved HL7 -> reference table -> none. Always present; may have source NONE. */
  referenceRange: ReferenceRange;
  /** Only on additionalBiomarkers: the panel slot that REFUSED this result because its unit is not one that slot allows (e.g. an MPO antibody in AI against the plasma MPO slot). Never shown as that slot's value. */
  rejectedForSlot?: Maybe<Scalars['String']['output']>;
  reportedAt?: Maybe<Scalars['String']['output']>;
  /** The unit Quest actually reported. Known to disagree with `unit` for absolute cell counts. */
  reportedUnit?: Maybe<Scalars['String']['output']>;
  /** Null for an off-panel result. */
  section?: Maybe<Scalars['String']['output']>;
  /** OBX-11. "F" (final) or "C" (a correction to a previous final) — both are final results. */
  status?: Maybe<Scalars['String']['output']>;
  /** OBR-22. Null when the message omitted it. */
  statusChangeDateTime?: Maybe<Scalars['String']['output']>;
  /** How many older results for this test were superseded. 0 when not repeated. */
  supersededCount: Scalars['Int']['output'];
  /** Display text for the theme. Group on themeCode. Null for an off-panel result. */
  theme?: Maybe<Scalars['String']['output']>;
  /** Stable code for theme. Null for an off-panel result, or when the reference entry has no valid stored code. */
  themeCode?: Maybe<ThemeCode>;
  /** Unit the reference table expects. May differ from reportedUnit — see referenceRange.reason. Null for an off-panel result. */
  unit?: Maybe<Scalars['String']['output']>;
  /** The value, classified into an explicit shape. Branch on __typename. */
  value: BiomarkerValue;
};

export type BiomarkerResult = Biomarker | BiomarkerUnavailable;

export type BiomarkerUnavailable = {
  __typename?: 'BiomarkerUnavailable';
  /** The panel slot's LOINC, the same key as Biomarker.loinc, so either branch joins to awpPriorityBiomarkers on it. */
  loinc: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** MDVIP theme, e.g. "Heart Health" — groups the gap with its panel. Display text; group on themeCode. */
  theme?: Maybe<Scalars['String']['output']>;
  /** Stable code for theme. Null only when the reference entry has no valid stored code. */
  themeCode?: Maybe<ThemeCode>;
};

export type BiomarkerValue = ComparatorBiomarkerValue | IndeterminateBiomarkerValue | NotPerformedBiomarkerValue | NotReportableBiomarkerValue | NumericBiomarkerValue | StringBiomarkerValue | TiterBiomarkerValue;

export type ComparatorBiomarkerValue = {
  __typename?: 'ComparatorBiomarkerValue';
  /** The bound itself, not a measurement. */
  number: Scalars['Float']['output'];
  operator: ComparatorOperator;
  raw: Scalars['String']['output'];
};

/** Direction of a bounded value: <, <=, > or >=. */
export type ComparatorOperator =
  | 'GT'
  | 'GTE'
  | 'LT'
  | 'LTE';

export type EarlierResult = {
  __typename?: 'EarlierResult';
  abnormalFlag?: Maybe<Scalars['String']['output']>;
  accession: Scalars['String']['output'];
  collectedAt: Scalars['String']['output'];
  reportedAt?: Maybe<Scalars['String']['output']>;
  reportedUnit?: Maybe<Scalars['String']['output']>;
  statusChangeDateTime?: Maybe<Scalars['String']['output']>;
  /** Classified like Biomarker.value, in the slot's unit. */
  value: BiomarkerValue;
};

export type FieldValue = {
  __typename?: 'FieldValue';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type IndeterminateBiomarkerValue = {
  __typename?: 'IndeterminateBiomarkerValue';
  raw: Scalars['String']['output'];
  /** Which case fired, e.g. declared_numeric_but_not_a_number. */
  reason: Scalars['String']['output'];
};

export type LabResult = {
  __typename?: 'LabResult';
  abnormalFlag?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  referenceRange?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusChangeDateTime?: Maybe<Scalars['String']['output']>;
  subId?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type LabSpecimen = {
  __typename?: 'LabSpecimen';
  collectedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  reportedAt?: Maybe<Scalars['String']['output']>;
  results: Array<LabResult>;
};

/** Which explicit mapping rule placed a result in its panel slot. */
export type MatchedBy = {
  __typename?: 'MatchedBy';
  code: Scalars['String']['output'];
  /** How ingest reconciled the reported unit with this slot's unit: IDENTITY (same unit, spelling aside), CONVERTED (converted into `unit`; value.number and the range are in `unit`, value.raw is what the lab sent), or NOT_NUMERIC (unit fine, value is not a number). */
  normalization: Scalars['String']['output'];
  /** The unit exactly as Quest reported it. */
  reportedUnit: Scalars['String']['output'];
  /** LOINC (OBX-3.1) or QUEST_LOCAL (OBX-3.4, used only when OBX-3.1 is blank). */
  system: Scalars['String']['output'];
};

export type MemberRecord = {
  __typename?: 'MemberRecord';
  accession: Scalars['String']['output'];
  encounterDate?: Maybe<Scalars['String']['output']>;
  fields: Array<FieldValue>;
  observations: Array<ObservationValue>;
  patientRef: Scalars['String']['output'];
  sex?: Maybe<Scalars['String']['output']>;
};

export type NotPerformedBiomarkerValue = {
  __typename?: 'NotPerformedBiomarkerValue';
  raw: Scalars['String']['output'];
};

export type NotReportableBiomarkerValue = {
  __typename?: 'NotReportableBiomarkerValue';
  /** Reviewed token: TNP_WITH_LIMIT, LOR, NOT_CALCULATED or NOT_APPLICABLE. */
  code: Scalars['String']['output'];
  raw: Scalars['String']['output'];
  /** Plain-language meaning of `code`, suitable for display. */
  reason: Scalars['String']['output'];
};

export type NumericBiomarkerValue = {
  __typename?: 'NumericBiomarkerValue';
  number: Scalars['Float']['output'];
  raw: Scalars['String']['output'];
};

export type ObservationValue = {
  __typename?: 'ObservationValue';
  abnormalFlag?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  referenceRange?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subId?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** One priority biomarker of a theme. Join on `loinc` to the same member's `awp` biomarkers to render its card. */
export type PriorityBiomarker = {
  __typename?: 'PriorityBiomarker';
  /** The panel slot's LOINC: the same key as Biomarker.loinc in `awp`. */
  loinc: Scalars['String']['output'];
  /** The reference document's name for the slot. */
  name: Scalars['String']['output'];
  /** 1-based position in the theme's list. */
  rank: Scalars['Int']['output'];
};

/** Where a theme's priority list came from: DEFAULT (MDVIP's default for the theme) or CUSTOM (chosen by the member's attending physician). */
export type PrioritySource =
  | 'CUSTOM'
  | 'DEFAULT';

export type Query = {
  __typename?: 'Query';
  /** The AWP (Annual Wellness Plan) panel for a visit: every biomarker named in the lab reference document, each with its reference metadata and chart bands, plus the LATEST result for that biomarker from the 14-day window starting at appointmentDate — or a BiomarkerUnavailable entry when it was not drawn. The list is fixed and identically ordered for every patient, so a chart can render the same rows every time and show what is missing, which a plain list of returned specimens cannot express. In-window results the document does not name are returned under additionalBiomarkers rather than dropped. `memberId` is the real MDVIP membership id; `appointmentDate` is a calendar date in YYYY-MM-DD form. Requires a delegated (signed-in physician) token; an app-only service credential is rejected. */
  awp: Awp;
  /** Each AWP health theme's priority biomarkers for a member, in rank order: one entry per ThemeCode, in ThemeCode order. A per-member setting, not part of a visit, so it takes no date and reads no lab results; fetch it once and join each `loinc` to the current visit's `awp` biomarkers (a Biomarker renders a card, a BiomarkerUnavailable a dash card). Same access rule as `awp`. `memberId` is the real MDVIP membership id. Requires a delegated (signed-in physician) token; an app-only service credential is rejected. */
  awpPriorityBiomarkers: Array<ThemePriorityBiomarkers>;
  /** Look up one member's specimen record by (patientRef, accession) — the same Cosmos identity labs-worker writes under. Callers holding an MDVIP memberId must resolve it to a questExternalId first, or use the `patientLabs` query, which does that resolution itself (and requires a delegated physician token). */
  memberRecord: MemberRecord;
  /** Every lab specimen for a patient, most recent first. `memberId` is the real MDVIP membership id — never the internal questExternalId pseudonym, which this API resolves itself. Requires a delegated (signed-in physician) token; an app-only service credential is rejected. */
  patientLabs: Array<LabSpecimen>;
  /** List Quest's SFTP inbound directory (the one quest-hl7-download reads) with each entry's metadata. Read-only: nothing is downloaded, moved or deleted. Available ONLY through the GraphQL explorer. */
  sftpInboundFiles: SftpDirectoryListingType;
};


export type QueryAwpArgs = {
  appointmentDate: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};


export type QueryAwpPriorityBiomarkersArgs = {
  memberId: Scalars['String']['input'];
};


export type QueryMemberRecordArgs = {
  accession: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
};


export type QueryPatientLabsArgs = {
  memberId: Scalars['String']['input'];
};


export type QuerySftpInboundFilesArgs = {
  orderBy?: InputMaybe<SftpFileOrderBy>;
};

/** One tier of the reference table's range. A value is in the band if it satisfies ANY clause. */
export type ReferenceBand = {
  __typename?: 'ReferenceBand';
  clauses: Array<ReferenceBandClause>;
  /** As the table wrote it, e.g. "Optimal", "Moderate", "High"; "Normal" when the table gives a bare interval. */
  label: Scalars['String']['output'];
};

/** One comparison in a band. `value` is set for LT/LTE/GT/GTE; `low` and `high` only for BETWEEN. */
export type ReferenceBandClause = {
  __typename?: 'ReferenceBandClause';
  high?: Maybe<Scalars['Float']['output']>;
  low?: Maybe<Scalars['Float']['output']>;
  op: ReferenceBandOperator;
  value?: Maybe<Scalars['Float']['output']>;
};

/** How a band clause compares: LT/LTE/GT/GTE against `value`, or BETWEEN `low` and `high` inclusive. */
export type ReferenceBandOperator =
  | 'BETWEEN'
  | 'GT'
  | 'GTE'
  | 'LT'
  | 'LTE';

export type ReferenceRange = {
  __typename?: 'ReferenceRange';
  /** Null means no upper bound. */
  high?: Maybe<Scalars['Float']['output']>;
  highInclusive: Scalars['Boolean']['output'];
  /** OBX-7 exactly as sent, kept even when it was not the source used. Null when the message carried none. */
  hl7Raw?: Maybe<Scalars['String']['output']>;
  /** Null means no lower bound. */
  low?: Maybe<Scalars['Float']['output']>;
  lowInclusive: Scalars['Boolean']['output'];
  /** Non-null only when source is NONE; names which case fired. */
  reason?: Maybe<Scalars['String']['output']>;
  source: ReferenceRangeSource;
  /** Verbatim source text; null when source is NONE. */
  text?: Maybe<Scalars['String']['output']>;
  /** The unit the range is expressed in. Null when source is NONE. */
  unit?: Maybe<Scalars['String']['output']>;
};

/** Where a normal reference range came from: HL7 (the message's own OBX-7, specific to this specimen), AWP_REFERENCE_TABLE (the curated document, used when the message carried no usable range), or NONE. */
export type ReferenceRangeSource =
  | 'AWP_REFERENCE_TABLE'
  | 'HL7'
  | 'NONE';

export type SftpDirectoryListingType = {
  __typename?: 'SftpDirectoryListingType';
  count: Scalars['Int']['output'];
  files: Array<SftpFile>;
  /** When the listing was taken (ISO-8601, UTC). */
  listedAt: Scalars['String']['output'];
  remoteDir: Scalars['String']['output'];
};

/** What kind of directory entry the SFTP server reported. */
export type SftpEntryType =
  | 'DIRECTORY'
  | 'FILE'
  | 'OTHER'
  | 'SYMLINK';

/** One entry in the SFTP inbound directory. Metadata only; file contents are never read. */
export type SftpFile = {
  __typename?: 'SftpFile';
  /** Last-accessed time (ISO-8601, UTC). */
  accessedAt: Scalars['String']['output'];
  /** The UTC timestamp Quest embeds in the filename (MDDVIP_<YYYYMMDDHHMMSSmmm>.hl7), as ISO-8601. Null when the name carries none. The closest proxy for when the file was added. */
  filenameTimestamp?: Maybe<Scalars['String']['output']>;
  group: Scalars['Int']['output'];
  /** True when quest-hl7-download would pick this entry up (regular file matching SFTP_FILE_PATTERN). */
  matchesIngestPattern: Scalars['Boolean']['output'];
  /** Last-modified time (ISO-8601, UTC). */
  modifiedAt: Scalars['String']['output'];
  name: Scalars['String']['output'];
  owner: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  permissions: SftpPermissions;
  sizeBytes: Scalars['Float']['output'];
  type: SftpEntryType;
  /** True for a regular file with no content. quest-hl7-download skips these until they fill in. */
  zeroByte: Scalars['Boolean']['output'];
};

/** Sort order for sftpInboundFiles. Ties always break by name, ascending. */
export type SftpFileOrderBy = {
  direction?: SortDirection;
  field?: SftpFileSortField;
};

/** What to sort the listing by. SFTP reports no creation time, so there is no true 'date added'. FILENAME_TIMESTAMP (the time Quest embeds in the filename) is the closest proxy, and is what quest-hl7-download orders a backlog by. MODIFIED_AT is when the file last changed on the server. */
export type SftpFileSortField =
  /** Last-accessed time on the SFTP server. */
  | 'ACCESSED_AT'
  /** Timestamp embedded in Quest's filename (closest proxy for date added). Names without one sort last. */
  | 'FILENAME_TIMESTAMP'
  /** Last-modified time on the SFTP server (date updated). */
  | 'MODIFIED_AT'
  /** File name, byte order. */
  | 'NAME'
  /** Size in bytes. */
  | 'SIZE';

/** rwx permission letters as the SFTP server reports them, per class. */
export type SftpPermissions = {
  __typename?: 'SftpPermissions';
  group: Scalars['String']['output'];
  other: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type SortDirection =
  | 'ASC'
  | 'DESC';

export type StringBiomarkerValue = {
  __typename?: 'StringBiomarkerValue';
  raw: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/** Stable identifier for an AWP health theme. Group on this, not on `theme`; display labels are the client's. */
export type ThemeCode =
  | 'BRAIN_COGNITIVE'
  | 'HEART_HEALTH'
  | 'LONGEVITY_WELLNESS'
  | 'METABOLIC_HEALTH';

/** A health theme's priority biomarkers, in rank order. */
export type ThemePriorityBiomarkers = {
  __typename?: 'ThemePriorityBiomarkers';
  /** In rank order. Empty only when the theme has no valid list, which the API logs; render the theme without priority cards. */
  biomarkers: Array<PriorityBiomarker>;
  source: PrioritySource;
  themeCode: ThemeCode;
};

export type TiterBiomarkerValue = {
  __typename?: 'TiterBiomarkerValue';
  denominator: Scalars['Int']['output'];
  numerator: Scalars['Int']['output'];
  raw: Scalars['String']['output'];
};

export type AwpQueryVariables = Exact<{
  memberId: Scalars['String']['input'];
  appointmentDate: Scalars['String']['input'];
}>;


export type AwpQuery = { __typename?: 'Query', awp: { __typename?: 'Awp', appointmentDate: string, biomarkers: Array<
      | { __typename: 'Biomarker', loinc: string, name: string, themeCode?: ThemeCode | null, unit?: string | null, collectedAt: string, value:
          | { __typename: 'ComparatorBiomarkerValue', operator: ComparatorOperator, number: number }
          | { __typename: 'IndeterminateBiomarkerValue', raw: string }
          | { __typename: 'NotPerformedBiomarkerValue', raw: string }
          | { __typename: 'NotReportableBiomarkerValue', raw: string }
          | { __typename: 'NumericBiomarkerValue', number: number }
          | { __typename: 'StringBiomarkerValue', text: string }
          | { __typename: 'TiterBiomarkerValue', numerator: number, denominator: number }
        , referenceBands?: Array<{ __typename?: 'ReferenceBand', label: string, clauses: Array<{ __typename?: 'ReferenceBandClause', op: ReferenceBandOperator, value?: number | null, low?: number | null, high?: number | null }> }> | null }
      | { __typename: 'BiomarkerUnavailable', loinc: string, name: string, themeCode?: ThemeCode | null }
    > } };

export type AwpPriorityBiomarkersQueryVariables = Exact<{
  memberId: Scalars['String']['input'];
}>;


export type AwpPriorityBiomarkersQuery = { __typename?: 'Query', awpPriorityBiomarkers: Array<{ __typename?: 'ThemePriorityBiomarkers', themeCode: ThemeCode, biomarkers: Array<{ __typename?: 'PriorityBiomarker', loinc: string, name: string, rank: number }> }> };


export const AwpDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Awp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"appointmentDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}},{"kind":"Argument","name":{"kind":"Name","value":"appointmentDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"appointmentDate"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appointmentDate"}},{"kind":"Field","name":{"kind":"Name","value":"biomarkers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BiomarkerUnavailable"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loinc"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"themeCode"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Biomarker"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loinc"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"themeCode"}},{"kind":"Field","name":{"kind":"Name","value":"unit"}},{"kind":"Field","name":{"kind":"Name","value":"collectedAt"}},{"kind":"Field","name":{"kind":"Name","value":"value"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NumericBiomarkerValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComparatorBiomarkerValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"operator"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"TiterBiomarkerValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"numerator"}},{"kind":"Field","name":{"kind":"Name","value":"denominator"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"StringBiomarkerValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotPerformedBiomarkerValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NotReportableBiomarkerValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"IndeterminateBiomarkerValue"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"raw"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"referenceBands"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"clauses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"op"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"low"}},{"kind":"Field","name":{"kind":"Name","value":"high"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AwpQuery, AwpQueryVariables>;
export const AwpPriorityBiomarkersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AwpPriorityBiomarkers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"awpPriorityBiomarkers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"themeCode"}},{"kind":"Field","name":{"kind":"Name","value":"biomarkers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loinc"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"rank"}}]}}]}}]}}]} as unknown as DocumentNode<AwpPriorityBiomarkersQuery, AwpPriorityBiomarkersQueryVariables>;